import { useQuery } from "@tanstack/react-query";
import api, { RestApiOptions } from "@/api";
import { ExportablesGenerationResponse } from "@/types/models/Exportables.interface";
import getApplicationEnvironment from "@/utils/getApplicationEnvironment";
const { isDevEnv, isFeatureEnv } = getApplicationEnvironment();

const options: RestApiOptions = {
  basePath: isDevEnv || isFeatureEnv ? "https://app.dev.newseladev.com/" : "/",
  timeout: 40000,
};
const resource = `seti/generate-exportables-metadata/`;

export function useGetExportables({
  articleId,
  levelId,
  skip = false,
}: {
  articleId?: string;
  levelId?: string;
  skip?: boolean;
}) {
  const hasRequiredParams = Boolean(articleId) && Boolean(levelId) && !skip;

  const query = useQuery<ExportablesGenerationResponse>({
    enabled: hasRequiredParams,
    queryKey: ["exportables", articleId, levelId],
    retry: 3,
    queryFn: async () =>
      api(options).post(
        resource,
        {
          article_story_content_id: articleId,
          article_level_content_id: levelId,
        },
        {},
      ),
    refetchOnWindowFocus: false,
  });

  const hasQueryError = !query?.isLoading && query?.isError;

  if (hasQueryError || !hasRequiredParams) {
    return {
      ...query,
      loading: false,
      error: !hasRequiredParams
        ? "required articleId or levelId parameter is missing"
        : query?.error,
      data: undefined,
    };
  }

  return { loading: query?.isFetching, ...query };
}

export default useGetExportables;
